<template>
  <div class="param-edit">
    <el-form class="zwx-form" style="padding: 0 !important;" key="mainForm" ref="mainForm" :model="mainForm" :rules="rules" label-position="right">
      <!-- 基础信息部分 -->
      <headline title="基本信息" class="headline" />
      <el-divider class="base-divider" />
      <div style="max-width: 282px; padding: 10px 0 5px 20px !important;">
        <el-form-item label-width="82px" label="参数名称：" prop="parameterKey">
          <el-input class="zwx-input" v-model="mainForm.parameterKey" maxlength="50" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label-width="82px" label="参数值：" prop="parameterValue">
          <el-input class="zwx-input" v-model="mainForm.parameterValue" maxlength="500" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label-width="82px" label="参数描述：" prop="parameterDescription">
          <el-input class="zwx-input" v-model="mainForm.parameterDescription" maxlength="100" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label-width="82px" label="状态：" required>
          <el-radio-group class="zwx-radio-group" v-model="mainForm.ifEnable">
            <el-radio class="zwx-radio" :label="true">启用</el-radio>
            <el-radio class="zwx-radio" :label="false">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </div>
    </el-form>
    <el-divider class="base-divider" />
    <!-- 提交部分 -->
    <div style="padding: 12px 20px;">
      <el-button class="zwx-button zwx-button-28" type="primary" @click="$system.valid($refs['mainForm'], '提示', '确定要提交吗？', '确定', '取消', commit)">提交</el-button>
      <el-button class="zwx-button zwx-button-28" @click="back()">返回</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ParamEdit',
  data() {
    return {
      api: this.$store.state.api,
      users: this.$store.state.users,
      rid: this.$route.params.rid,
      mainForm: {
        parameterKey: '',
        parameterValue: '',
        parameterDescription: '',
        ifEnable: true,
      },
      rules: {
        parameterKey: [{ required: true, message: '请输入参数名称', trigger: ['change', 'blur'] }],
        parameterValue: [{ required: true, message: '请输入参数值', trigger: ['change', 'blur'] }],
        parameterDescription: [{ required: true, message: '请输入参数描述', trigger: ['change', 'blur'] }],
      },
    }
  },
  created() {},
  mounted() {
    this.detail()
  },
  computed: {
    breadcrumbs() {
      return this.$store.state.breadcrumbs
    },
  },
  methods: {
    detail() {
      if (this.rid === undefined) return
      this.$emit('loading', true)
      let data = {
        rid: this.rid,
      }
      this.$system.get(this.api + '/systematic/getParameter-1', data, true, true, this.detailSuccess, this.detailError)
    },
    detailSuccess(data) {
      if (data.type === '00') {
        this.mainForm.parameterKey = data.parameter.parameterKey
        this.mainForm.parameterValue = data.parameter.parameterValue
        this.mainForm.parameterDescription = data.parameter.parameterDescription
        this.mainForm.ifEnable = data.parameter.ifEnable
        this.$emit('loading', false)
      } else if (data.type === '99') {
        this.$router.push({ name: 'ErrorPage', params: { mess: data.mess } })
      } else {
        this.$system.notify('错误', data.mess, 'error')
        this.$emit('loading', false)
        this.back()
      }
    },
    detailError() {
      this.$system.notify('错误', '网络连接失败', 'error')
      this.$emit('loading', false)
      this.back()
    },
    commit() {
      this.$emit('loading', true)
      let data = {
        rid: this.rid,
        parameterKey: this.mainForm.parameterKey,
        parameterValue: this.mainForm.parameterValue,
        parameterDescription: this.mainForm.parameterDescription,
        ifEnable: this.mainForm.ifEnable,
      }
      this.$system.postJson(this.api + '/systematic/addOrModifyParameter-1', data, true, true, this.commitSuccess, this.commitError)
    },
    commitSuccess(data) {
      if (data.type === '00') {
        this.$system.notify('成功', data.mess, 'success')
        this.$router.replace({ name: this.breadcrumbs[this.breadcrumbs.length - 2].name, params: { fresh: true } })
      } else if (data.type === '99') {
        this.$router.push({ name: 'ErrorPage', params: { mess: data.mess } })
      } else {
        this.$system.notify('错误', data.mess, 'error')
        this.$emit('loading', false)
      }
    },
    commitError() {
      this.$system.notify('错误', '网络连接失败', 'error')
      this.$emit('loading', false)
    },
    back() {
      this.$router.replace({ name: this.breadcrumbs[this.breadcrumbs.length - 2].name })
    },
  },
}
</script>

<style lang="less" scoped></style>

<style lang="less"></style>
